import utils from '@src/common/utils'
const tableOption = function(that) {
  const validatePass = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请再次输入密码'))
    } else if (value !== that.account.password) {
      callback(new Error('两次输入密码不一致!'))
    } else {
      callback()
    }
  }

  const validateName = (rule, value, callback) => {
    var reg = new RegExp('^[a-zA-Z][0-9a-zA-Z_]+$')
    if (!reg.test(value)) {
      callback(new Error('必须是数字、字母、下划线，且首字符为字母；不能含特殊字符'))
    } else {
      callback()
    }
  }

  const validatePwd = (rule, value, callback) => {
    var reg = new RegExp('^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^\\s0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^\\s0-9a-zA-Z]))[^\\s]+)$')
    if (!reg.test(value)) {
      callback(new Error('密码格式不正确'))
    } else {
      callback()
    }
  }

  const validatePhone = (rule, value, callback) => {
    var reg = new RegExp('^1[3456789]\\d{9}$')
    if (!reg.test(value)) {
      callback(new Error('手机号码格式不正确'))
    } else {
      callback()
    }
  }

  const validateEmails = (rule, value, callback) => {
    // var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$')
    var reg = new RegExp('^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$')
    if (!reg.test(value)) {
      callback(new Error('邮箱格式不正确'))
    } else if(value.indexOf('@') > 18 || value.indexOf('@') < 4){
      callback(new Error('邮箱前缀为 4 到 18 个字符'))
    }else {
      callback()
    }
  }

  return {
    add: '新增周界任务',
    edit: '修改账户',
    view: '查看周界任务',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    menuWidth: 200,
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: '：',
    labelWidth: '100px',
    dialogWidth: '800px',
    viewDialogWidth: '800px',
    emptyText: '暂无账户',
    column: [
      {
        label: '任务名称',
        prop: 'taskName',
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        search: true,
        searchPlaceholder: '请输入任务名称',
        span: 12,
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 1, max: 50, message: '任务名称长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
      // {
      //   label: '攝像機列表',
      //   // align: 'center',
      //   prop: 'cameraList',
      //   type: 'text',
      //   value: '',
      //   overHidden: true,
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   formatter: (row, value) => {
      //     console.log('row_c',row)
      //     let str = ''
      //     row.cameraList.map((val,index)=>{
      //         if (index!= row.cameraList.length - 1) {
      //           str += val.deviceName + ','
      //         }else{
      //           str += val.deviceName
      //         }
      //     })

      //     return str
      //   },
      //   span: 12
      // },
      {
        label: '启用状态',
        // align: 'center',
        prop: 'status',
        search: true,
        searchDefault: [],
        type: 'select',
        slot: true,
        addDisplay: false,
        editDisabled: false,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '启用'
          } else if (Number(value) === 2) {
            return '禁用'
          } else if (Number(value) === 3) {
            return '锁定'
          }
          return '';
        },
        searchPlaceholder: '请选择状态',
        dicData: [
          {
            label: '启用',
            value: 1
          },
          {
            label: '禁用',
            value: 2
          },
          {
            label: '锁定',
            value: 3
          }
        ],
        span: 12,
        rules: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
      },
      {
        label: '任务描述',
        prop: 'desc',
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        span: 12
      },
      {
        label: '摄像机列表',
        // align: 'center',
        prop: 'role',
        // type: 'text',
        value: '',
        overHidden: true,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        formatter: (row, value) => {
          console.log('row_c',row)
          let str = ''
          row.cameraList.map((val,index)=>{
              if (index!= row.cameraList.length - 1) {
                str += val.deviceName + ','
              }else{
                str += val.deviceName
              }
          })

          return str
        },
        formslot:true,
        viewslot:true,
        span: 24
      },
      {
        label: '创建时间',
        prop: 'createTime',
        type: 'datetime',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        overHidden: true,
        // format: 'yyyy-MM-dd hh:mm:ss',
        valueFormat: 'timestamp',
        span: 13,
        // align: 'center',
        formatter: function(row, value){
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      }
    //   {
    //     label: '任務描述',
    //     prop: 'desc',
    //     span: 24,
    //     type: 'textarea',
    //     hide: true,
    //     minRows: 3,
    //     maxlength: 200,
    //     overHidden: true,
    //     placeholder: '请输入备注信息',
    //     addDisplay: true
    //   }
    ]
  }
}
export default tableOption